<template>
  <div class="addressMContent">
    <van-swipe-cell :right-width="120" :left-width="0" stop-propagation v-if="AddressList" v-for="(item,index) in AddressList" :key="index">
      <a href="javascript:;" class="billBar" @click="getAddressRepair(item)">
        <van-row>
          <van-col span="3" >
            <van-tag color="#ff6d02" class="Status" v-if="index%2==0">{{item.tag}}</van-tag>
            <van-tag type="primary" class="Status" v-if="index%2!=0">{{item.tag}}</van-tag>
          </van-col>
          <van-col span="21">
            <van-row>
              <van-col span="24" class="address">{{item.province+item.city+item.area+item.villageName+item.address}}</van-col>
              <van-col span="18" class="statusText">用热面积：{{item.useArea}}m<sup>2</sup></van-col>
              <van-col span="6" class="tag textR" v-if="item.default_flag==1"><van-tag color="#ff6d02" plain>默认</van-tag></van-col>
            </van-row>
          </van-col>
        </van-row>
      </a>
      <template slot="right">
        <van-button square type="danger" text="删除" @click="onDelete(item)"/>
        <van-button square type="primary" text="编辑" @click="onEdit(item)" class="edit"/>
      </template>
    </van-swipe-cell>
    <div class="addAddressBtn">
      <van-button type="primary" size="large" @click="addAddress">新增房屋地址</van-button>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { Dialog } from 'vant';
  import { reqAddressList, reqAddressDel } from '../../api'
	export default {
    name:"addressmanage",
    data(){
      return{
        userId:'',
        AddressList:[]
      }
    },
    created(){
      this.userId = this.$cookies.get('userInfo').userId
    },
    mounted(){
      this.getAddressList();
    },
    methods:{
      /*
      * 获取地址来供热保修
      * */
      getAddressRepair(item){
		  //query.type 1 报修 ； 2 供热状态变更
        if(this.$route.query.type=='1'){
          let address = item.address
          this.$cookies.remove('address');
          this.$cookies.set('address',address);
          this.$router.replace({
            path:'/reportrepair',
            name:'reportrepair',
            query:{roomId:item.roomId}
          })
        }else if(this.$route.query.type=='2'){
			let address = item.address
			this.$cookies.remove('address');
			this.$cookies.set('address',address);
			this.$router.replace({
			  path:'/stop',
			  name:'stop',
			  query:{roomId:item.roomId}
			})
		}
      },
      /*
      * 获取订单列表
      * */
      getAddressList(){
        let data={
          userId:this.userId
        }
        //获取对应小区
        reqAddressList(data).then(res => {
          if(res.success){
            this.AddressList = res.data
            if(this.AddressList.length==0){
              Toast.fail({message:'暂无地址信息！',className:'apiLoading'});
            }
          }else {
            Toast.fail({message:res.msg,className:'apiLoading'});
          }
        })
      },
      /*
      * 跳转新增地址
      * */
      addAddress(){
        this.$router.push({
          path:'/addaddress',
          name:'addaddress',
        });
      },
      /*
     * 跳转编辑地址
     * */
      addAddress(){
        this.$router.push({
          path:'/addaddress',
          name:'addaddress',
        });
      },
      /*
      * 滑块删除
      * */
      onDelete(item){
        Dialog.confirm({
          title: '提示',
          message: '确定删除吗？'
        }).then(() => {
          let data = {
            userId:this.userId,
            roomId:item.roomId
          }
          reqAddressDel(data).then(res => {
            if(res.success){
              this.getAddressList();
              Toast.success({message:'删除成功！',className:'apiLoading'});
            }else {
              Toast.fail({message:res.msg,className:'apiLoading'});
            }
          })
          // on confirm
        }).catch(() => {
          // on cancel
        });
      },
      /*
      * 滑块编辑地址
      * */
      onEdit(item){
        this.$router.push({
          path:'/addaddress',
          name:'addaddress',
          query:{roomId:item.roomId}
        });
      },

    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .orange
    color #ff6d02
  .addressMContent
    padding-bottom 80px
    background #f9f9f9
    .billBar
      display block
      padding 40px 40px 30px 0px
      background #fff
      border-top 20px solid #f9f9f9
      .tag
        .van-tag
          font-size 22px
          position relative
          padding 10px
          right 5px
          top 20px
          margin 5px 0px
      .Status
        display inline-block
        border-radius 50%
        width 80px
        height 30px
        text-align center
        padding 25px 0px
        color #fff
        font-size 28px
      sup
        vertical-align super
        font-size smaller
      .van-row
        padding-left 25px
      .address
        border-bottom 2px solid #f0f0f0
        font-size 30px
        color #222222
        line-height 40px
        padding 5px 0px 10px
      .statusText
        padding-top 20px
        font-size 28px
        color #888888
    .van-swipe-cell__right
      padding-top 20px
      .van-button
        margin-right -6px
        width 120px
        height 100%
        font-size 28px
        text-align center
        letter-spacing 6px
      .edit
        background #dadee1
        border 2px solid #dadee1
    .addAddressBtn
      width 100%
      position fixed
      bottom 0px
      left 0
      .van-button
        height 120px
        padding 20px 0px
        font-size 34px
        background #ff6d02
        .van-button__text
          padding-left 50px
          background url("./images/addico.png") no-repeat center left
          background-size 40px 40px
</style>



// WEBPACK FOOTER //
// src/pages/AddressManage/AddressManage.vue